import React from 'react';

const EditorialFooter = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer-editorial">
      <div className="footer-content">
        <div className="flex items-center space-x-3">
          <div className="footer-brand">
            blackgamersnetwork
          </div>
        </div>
        
        <div className="footer-page">
          001
        </div>
      </div>
      
      {/* Additional footer content for other pages */}
      <div className="mt-8 pt-8 border-t border-gray-200 text-center">
        <p className="body-small text-gray-500">
          © {currentYear} Black Gamers Network. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default EditorialFooter;